import React, { Component } from 'react'

import Hero from './home/Hero'
import Message from './home/Message'
import Tshirts from '../container/home/Tshirts'
import Bullying from './home/Bullying'
import HostParty from './home/HostParty'
import News from './home/News'
import About from './home/About'
import Vip from './home/Vip'

class Content extends Component {

  render() {
    return (
      <div>
        <Hero />
        <Message />
        <Tshirts />
        <Bullying />
        <HostParty />
        <News />
        <About />
        <Vip />
      </div>
    );
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/Home.js